module.exports = __webpack_public_path__ + "img/49441ddf0a6164b1df8eac014fe55532.a671eafe.png";